module.exports = __webpack_public_path__ + "static/media/gasnet3.17dff845.gif";